import isFilledUp from './fields/isFilledUp'
// import isPersonName from './fields/isPersonName'
import isEmail from './fields/isEmail'
import isMobileNumber from './fields/isMobileNumber'

const validateFirstName = (name, firstName) => {
  if (!isFilledUp(firstName)) {
    return { [name]: 'First name is required' }
  }
  // if (!isPersonName(firstName)) {
  //   return { [name]: 'First name contains invalid characters' }
  // }
  return {}
}

const validateLastName = (name, firstName) => {
  if (!isFilledUp(firstName)) {
    return { [name]: 'Last name is required' }
  }
  // if (!isPersonName(firstName)) {
  //   return { [name]: 'Last name contains invalid characters' }
  // }
  return {}
}

const validateEmail = (name, email) => {
  if (!isFilledUp(email)) {
    return { [name]: 'Email is required' }
  }
  if (!isEmail(email)) {
    return { [name]: 'Invalid email' }
  }
  return {}
}

const validateMobileNumber = (name, mobileNumber) => {
  if (!isFilledUp(mobileNumber)) {
    return { [name]: 'Mobile number is required' }
  }
  if (!isMobileNumber(mobileNumber)) {
    return { [name]: 'Invalid mobile number' }
  }
  return {}
}

function validateSubject(name, type) {
  if (!isFilledUp(type)) {
    return { [name]: 'Subject is required' }
  }
  return {}
}

const validateMessage = (name, message) => {
  if (!isFilledUp(message)) {
    return { [name]: 'Message is required' }
  }
  return {}
}

const validate = values => {
  if (typeof values !== 'object' || values === null) {
    throw new Error(
      'Invalid argument. Validator functions only expect a non-null object.',
    )
  }

  const { firstName, lastName, email, mobileNumber, type, message } = values

  return {
    ...validateFirstName('firstName', firstName),
    ...validateLastName('lastName', lastName),
    ...validateEmail('email', email),
    ...validateMobileNumber('mobileNumber', mobileNumber),
    ...validateSubject('type', type),
    ...validateMessage('message', message),
  }
}

export default validate
